import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { ResgateParcialService } from '@services';
import { addMonths, endOfMonth, format, isWeekend, subDays } from 'date-fns';
import {
  gerarComprovamenteResgateParcialPDF,
  gerarMemoriaCalculoResgateParcialPDF,
} from '../utils/resgate-parcial';

export const HistoricoResgateParcial = () => {
  const { matricula, plano, nome, token } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const obterHistoricoResgateParcial = useCallback(async () => {
    setLoading(true);
    const service = new ResgateParcialService();
    setHistorico(await service.ObterHistoricoResgateParcial(matricula, plano));
    setLoading(false);
  }, [matricula, plano]);

  useEffect(() => {
    obterHistoricoResgateParcial();
  }, [obterHistoricoResgateParcial]);

  // Função para verificar se um dia é um dia útil (não é sábado nem domingo)
  function isBusinessDay(date) {
    return !isWeekend(date);
  }

  // Função para obter o último dia útil de um mês
  function getLastBusinessDayOfMonth(date) {
    let lastDayOfMonth = endOfMonth(date);
    while (!isBusinessDay(lastDayOfMonth)) {
      lastDayOfMonth = subDays(lastDayOfMonth, 1);
    }
    return lastDayOfMonth;
  }

  return !loading ? (
    <>
      <Helmet>
        <title>Histórico de Pedidos de Resgate Parcial</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico de Pedidos de Resgate Parcial
            <Tooltip title="Veja o histórico de Pedidos de Resgate Parcial">
              ?
            </Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Protocolo',
              'Data Solicitação',
              'Percentual resgatado do saldo',
              // 'Percentual remanescente Parcela à vista',
              'Previsão de crédito',
              'Termo opção',
              'Memória de cálculo',
              'Status',
            ]}
          >
            {historico.map((linha) => {
              const [datePart, timePart] = linha.DataPedido.split(' ');
              const [day, month, year] = datePart.split('/');
              const dataFormatadaCompleta = `${year}-${month}-${day} ${timePart}`;
              return (
                <tr key={linha.Protocolo}>
                  <td>{linha.Protocolo}</td>
                  <td>{linha.DataPedido}</td>
                  <td>
                    {Number(linha.PercentualResgatado) &&
                    linha.Status !== 'Cancelada'
                      ? `${linha.PercentualResgatado}%`
                      : '-'}
                  </td>
                  {/* <td>
                    {Number(linha.PercentualRemanescenteSaqueVista) &&
                    linha.Status !== 'Cancelada'
                      ? `${linha.PercentualRemanescenteSaqueVista}%`
                      : '-'}
                  </td> */}
                  <td>
                    {linha.Status !== 'Cancelada'
                      ? format(
                          getLastBusinessDayOfMonth(
                            addMonths(new Date(dataFormatadaCompleta), 1)
                          ),
                          'dd/MM/yyyy'
                        )
                      : '-'}
                  </td>
                  <td>
                    {linha.Status !== 'Cancelada' ? (
                      <button
                        className="btn link"
                        onClick={() =>
                          gerarComprovamenteResgateParcialPDF({
                            registroResgate: linha,
                            nome,
                            plano,
                            token,
                          })
                        }
                      >
                        <p>Baixar Termo</p>
                      </button>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {linha.DataPagamento ? (
                      <button
                        className="btn link"
                        onClick={() =>
                          gerarMemoriaCalculoResgateParcialPDF(
                            matricula,
                            format(new Date(linha.DataPagamento), 'yyyyMM'),
                            token
                          )
                        }
                      >
                        <p>Baixar Memória de cálculo</p>
                      </button>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <b>{linha.Status}</b>
                  </td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
